import React from 'react';
const medios = [
  'Radio', 'Televisión', 'Internet',
  'Redes Sociales', 'Amigo/Familiar/Conocido'
]

export default class MedioInformado extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>2. </strong> &nbsp;
          ¿Podría indicar porque medio se informa?
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <select
            value={datos.medio !== "" ?  medios.findIndex((item) => item === datos.medio) !== -1 ? datos.medio : "Otro" : "Otro"}
            onChange={(e) => editar('medio', e.target.value)}
          >
            {medios.map((item, index) => {
              return(
                <option key={index}>{item}</option>
              )
            })}
            <option>Otro</option>
          </select>
          {medios.findIndex((item) => item === datos.medio) === -1 &&
            <input
              value={datos.medio}
              onChange={(e) => editar('medio', e.target.value)}
            />
          }
        </div>
      </div>
    )
  }
}
